/** Minimum human votes (or stats) for sitemap/index — OQ-3, aligned with ADR-008 thin-content gate. */
export const SITEMAP_MIN_VOTES = 5;
/** Player metrics from API payload (same source as getDuelBySlug lateral stats join). */
export function hasDuelEmbeddedPlayerMetrics(duel) {
    const hasMetrics = (player) => {
        if (!player) {
            return false;
        }
        return ((player.form != null && player.form !== '') ||
            (player.selected_by_percent != null && player.selected_by_percent !== '') ||
            (player.now_cost != null && typeof player.now_cost === 'number'));
    };
    return hasMetrics(duel.player_a) || hasMetrics(duel.player_b);
}
export function hasDuelPrerenderStats(stats) {
    if (!stats) {
        return false;
    }
    return Object.keys(stats.playerA).length > 0 || Object.keys(stats.playerB).length > 0;
}
/** Whether duel page should be indexed (votes ≥ threshold OR prerender/API stats). */
export function isDuelSeoIndexable(votes, stats, minVotes = SITEMAP_MIN_VOTES) {
    const totalVotes = votes.total_votes ?? 0;
    if (totalVotes >= minVotes) {
        return true;
    }
    return hasDuelPrerenderStats(stats);
}
/** Edge/client gate: prerender stats, else embedded player metrics from duel API payload. */
export function isDuelSeoIndexableFromDuel(duel, stats, minVotes = SITEMAP_MIN_VOTES) {
    if (isDuelSeoIndexable(duel.votes ?? {}, stats, minVotes)) {
        return true;
    }
    return hasDuelEmbeddedPlayerMetrics(duel);
}
